import { SessionStorage } from '../../common/cookie-storage'
import { STORAGEKEYS } from '../../common/keys'
import { LenConfigActions, SET_ANALYTICS_EVENT_TYPES_NAMES, SET_LEN_CONFIG, SET_PHONE_VISIBLE_ON_PAGE } from '../actions/len-config-actions'
import { ILenConfigState, LOADER_CONFIG_KEYS } from "../types";

export const lenConfigInitialState: ILenConfigState = {    
  analyticsEventTypesNames: undefined,

   footerConfig: {
      phoneNumber: '',
      isPhoneAvailable: false,
      isPhoneVisibleOnPage: false,
      officeOpenTime: '',
      officeClosedTime: '',
    },
    globalConfig: {
      invalidNipNumbers: [],
      invalidPeselNumbers: [],
      sendSmsBlockingTimeInMs: 0,
      sendSmsInitialBlockingTime: 0,
      sendSmsLimit: 0,
      minimumLoanAmount: 0,
      defaultOfferSliderSteps: [{from:0, value: 50}, {from: 10000, value:100}, {from: 15000, value:500}],
      manualVerificationPhoneNumber: '',
      affiliateCookieExpiresTimeInHours: undefined,
      leadRedirectionDelayInSeconds: 1,
      clientPeselReservedCheckBlockingTimeInSec: 0,
      mObywatelCodeValidationTimeInSeconds: 120,
      metaPixelEnabled: false,
      leadBaseLinks: {},
      workTimeFrom: { 
            hours: 0, 
            minutes: 0
      },
      workTimeTo: { 
            hours: 0, 
            minutes: 0
      },
    },
    loadersConfig: {
      [LOADER_CONFIG_KEYS.OFFER_WAITING]: [
        {
          heading: "Zapisujemy wniosek",
          description: "Rejestrujemy wniosek w naszym systemie.",
          from: 0,
          to: 10
        },
        {
          heading: "Sprawdzamy poprawność",
          description: "Analizujemy dane podane we wniosku.",
          from: 10,
          to: 20
        },
        {
          heading: "Analizujemy dane",
          description: "Weryfikujemy Twoją historię kredytową w bazach zewnętrznych- może to chwilę potrwać.",
          from: 20,
          to: 40
        },
        {
          heading: "Weryfikacja w toku",
          description: "Weryfikujemy dodatkowe dane, aby przejść dalej.",
          from: 40,
          to: 60
        },
        {
          heading: "Kończymy analizę",
          description: "Trwa ostatni etap weryfikacji, za chwile otrzymasz decyzję.",
          from: 60,
          to: 90
        },
        {
          heading: "Jeszcze chwila",
          description: "Weryfikacja trwa dłużej niż zwykle. Daj nam jeszcze chwilę.",
          from: 90,
          to: 120
        },
        {
          heading: "System dziś trochę zwolnił",
          description: "Poczekaj tutaj albo wróć do procesu za chwilę, korzystając z linku, który wyślemy SMS-em, w przypadku pozytywnej decyzji kredytowej.",
          from: 120,
          to: null
        }
      ],
      [LOADER_CONFIG_KEYS.BM_WAITING]: [
        {
          heading: "Pobieramy dane",
          description: "Czekamy na udostępnione dane.",
          from: 0,
          to: 10
        },
        {
          heading: "Analizujemy dane",
          description: "Badamy Twoją zdolność kredytową.",
          from: 10,
          to: 25
        },
        {
          heading: "Przygotowujemy ofertę",
          description: "Obliczamy możliwą kwotę i okres spłaty.",
          from: 25,
          to: 40
        },
        {
          heading: "Prawie kończymy",
          description: "Został nam ostatni krok przed pokazaniem finalnej oferty pożyczki.",
          from: 40,
          to: 60
        },
        {
          heading: "Jeszcze chwila",
          description: "Weryfikacja trwa dłużej niż zwykle. Daj nam jeszcze chwilę.",
          from: 60,
          to: 120
        },
        {
          heading: "System dziś trochę zwolnił",
          description: "Poczekaj tutaj albo wróć do procesu za chwilę, korzystając z linku, który wyślemy SMS-em, w przypadku pozytywnej decyzji kredytowej.",
          from: 120,
          to: null
        }
      ],
    }
};
  
export function lenConfigReducer(
    state: ILenConfigState  = lenConfigInitialState,
    action: LenConfigActions
) {
      switch(action.type){
         case SET_LEN_CONFIG:{
          const sessionStorage = new SessionStorage()

          // Zapisujemy do sessionStorage wartości minimalnej kwoty pożyczki, aby można było z niej korzystać na późniejszych etapach
          sessionStorage.changeItemValue(STORAGEKEYS.SET_MINIMUM_LOAN_AMOUNT, action.payload.globalConfig.minimumLoanAmount.toString() ?? "")

           return{
               ...state,
               footerConfig: action.payload.footerConfig,
               globalConfig: action.payload.globalConfig,
               loadersConfig: action.payload.loadersConfig,
           }
         }
         case SET_PHONE_VISIBLE_ON_PAGE: {
           state.footerConfig.isPhoneVisibleOnPage = action.payload

           return {
               ...state,
           }
         }
         case SET_ANALYTICS_EVENT_TYPES_NAMES: {
          return {
              ...state,
              analyticsEventTypesNames: action.payload,
          }
        }
         default: {
           return state;
         }
      }
}
